import * as z from "zod/v4";

export const deleteTicketValidationResults = {
  name: "deleteTicketValidationResults" as const,
  input: z.object({ linearTicketId: z.string() }),
  output: z.object({ deletedCount: z.number() }),
};
